import { get, post } from "./fetch";

const checkToken = async (token) => get(`/departures/${token}`, null);

const submitReview = (review) => post("/reviews", review);

export { checkToken, submitReview };
